const React = require('react')
const { useEffect, useState } = require('react')
const { Container, Row, Col } = require('reactstrap')
const { useParams, useHistory } = require('react-router-dom')
const { useBlockchainData } = require('@hooks')
const { useNetworkConfig } = require('@contexts')
const { Tabs } = require('@components')

const { SlotDetails } = require('./details.slot')

require('@styles/pages/block/index.css')

const Slot = () => {
    const { slot } = useParams()
    const history = useHistory()
    const { network } = useNetworkConfig()
    const { getSlot, getBlocks } = useBlockchainData(network.name)

    const [loading, setLoading] = useState(false)
    const [slotData, setSlotData] = useState(null)
    const [latestBlock, setLatestBlock] = useState(0)

    const [activeTab, setActiveTab] = useState(() => {
        const urlHash = window.location.hash.slice(1)
        return urlHash || 'overview'
    })

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true)

                const [slotResponse, blocksResponse] = await Promise.all([getSlot(slot), getBlocks(1, 1)])

                if (slot > blocksResponse.totalItems - 1) {
                    history.push(`/${network.name}/block/countdown/${slot}`)
                    return
                }

                if (slotResponse && blocksResponse) {
                    setSlotData(slotResponse)
                    setLatestBlock(blocksResponse.totalItems - 1)
                }

                setLoading(false)
            } catch (error) {
                console.error('Error fetching data:', error)
                setLoading(false)
            }
        }
        fetchData()
    }, [slot])

    return (
        <div className='page'>
            <Container>
                <Col>
                    <Row>
                        <div className='page-header'>
                            <text className='page-title'>
                                Block at Slot Number
                                <span className='page-title-subcontent'>{` #${slot}`}</span>
                            </text>
                            <div className='page-title-border' />
                        </div>
                    </Row>
                    <Tabs
                        activeTab={activeTab}
                        items={[{ tab: 'overview', text: 'Overview' }]}
                        onTabChange={setActiveTab}
                    />
                    {activeTab === 'overview' && (
                        <SlotDetails loading={loading} data={slotData} latestBlock={latestBlock} />
                    )}
                </Col>
            </Container>
        </div>
    )
}

module.exports = Slot
